var _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4, _circle5, _path5, _circle6, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounDrag2422014(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 329.2,
    cy: 96.3,
    r: 43.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,96.3c-0.2,13.6-8.4,26.1-21.2,31c-13.3,5.1-28.6,1-37.7-9.9c-8.8-10.6-9.9-26-3-37.9      c6.9-11.8,20.7-18.4,34.2-16C350.7,66.3,362.1,80.2,362.4,96.3c0.2,12.9,20.2,12.9,20,0C382,73.6,367.9,53.7,346.5,46      c-20.3-7.3-44.3-0.5-58,16.1c-14.3,17.3-16.7,42.3-4.9,61.7c11.7,19.4,34.4,28.9,56.5,24.7c24.7-4.7,41.9-27.5,42.3-52.1      C382.6,83.4,362.6,83.4,362.4,96.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.2,
    cy: 247.9,
    r: 43.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,247.9c-0.2,13.6-8.4,26.1-21.2,31c-13.3,5.1-28.6,1-37.7-9.9c-8.8-10.6-9.9-26-3-37.9      c6.9-11.8,20.7-18.4,34.2-16C350.7,217.8,362.1,231.8,362.4,247.9c0.2,12.9,20.2,12.9,20,0c-0.4-22.7-14.5-42.6-35.9-50.3      c-20.3-7.3-44.3-0.5-58,16.1c-14.3,17.3-16.7,42.3-4.9,61.7c11.7,19.4,34.4,28.9,56.5,24.7c24.7-4.7,41.9-27.5,42.3-52.1      C382.6,235,362.6,235,362.4,247.9z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.2,
    cy: 403.6,
    r: 43.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.4,403.6c-0.2,13.6-8.4,26.1-21.2,31c-13.3,5.1-28.6,1-37.7-9.9c-8.8-10.6-9.9-26-3-37.9      c6.9-11.8,20.7-18.4,34.2-16C350.7,373.5,362.1,387.5,362.4,403.6c0.2,12.9,20.2,12.9,20,0c-0.4-22.7-14.5-42.6-35.9-50.3      c-20.3-7.3-44.3-0.5-58,16.1c-14.3,17.3-16.7,42.3-4.9,61.7c11.7,19.4,34.4,28.9,56.5,24.7c24.7-4.7,41.9-27.5,42.3-52.1      C382.6,390.7,362.6,390.7,362.4,403.6z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.7,
    cy: 96.9,
    r: 43.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9,96.9c-0.2,13.6-8.4,26.1-21.2,31c-13.3,5.1-28.6,1-37.7-9.9c-8.8-10.6-9.9-26-3-37.9      c6.9-11.8,20.7-18.4,34.2-16C192.3,66.9,203.7,80.8,203.9,96.9c0.2,12.9,20.2,12.9,20,0c-0.4-22.7-14.5-42.6-35.9-50.3      c-20.3-7.3-44.3-0.5-58,16.1c-14.3,17.3-16.7,42.3-4.9,61.7c11.7,19.4,34.4,28.9,56.5,24.7c24.7-4.7,41.9-27.5,42.3-52.1      C224.1,84,204.1,84,203.9,96.9z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.7,
    cy: 248.5,
    r: 43.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9,248.5c-0.2,13.6-8.4,26.1-21.2,31c-13.3,5.1-28.6,1-37.7-9.9c-8.8-10.6-9.9-26-3-37.9      c6.9-11.8,20.7-18.4,34.2-16C192.3,218.5,203.7,232.4,203.9,248.5c0.2,12.9,20.2,12.9,20,0c-0.4-22.7-14.5-42.6-35.9-50.3      c-20.3-7.3-44.3-0.5-58,16.1c-14.3,17.3-16.7,42.3-4.9,61.7c11.7,19.4,34.4,28.9,56.5,24.7c24.7-4.7,41.9-27.5,42.3-52.1      C224.1,235.6,204.1,235.6,203.9,248.5z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.7,
    cy: 404.2,
    r: 43.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9,404.2c-0.2,13.6-8.4,26.1-21.2,31c-13.3,5.1-28.6,1-37.7-9.9c-8.8-10.6-9.9-26-3-37.9      c6.9-11.8,20.7-18.4,34.2-16C192.3,374.1,203.7,388.1,203.9,404.2c0.2,12.9,20.2,12.9,20,0c-0.4-22.7-14.5-42.6-35.9-50.3      c-20.3-7.3-44.3-0.5-58,16.1c-14.3,17.3-16.7,42.3-4.9,61.6c11.7,19.4,34.4,28.9,56.5,24.7c24.7-4.7,41.9-27.5,42.3-52.1      C224.1,391.3,204.1,391.3,203.9,404.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounDrag2422014);
export default __webpack_public_path__ + "static/media/noun_drag_2422014.d1214087.svg";
export { ForwardRef as ReactComponent };